import isEmpty from 'lodash/isEmpty';

import { TrackingPixel } from '../types/TrackingPixel';
import { TrackingPixelTrackOptions } from '../types/TrackingPixelTrackOptions';

export const toTrackOptions = (
  pixels: TrackingPixel[],
): TrackingPixelTrackOptions | null => {
  // a vendor the Service could not map arrives as null and has no plugin
  const routedPixels = pixels.filter(({ vendor }): boolean => Boolean(vendor));

  if (isEmpty(routedPixels)) {
    return null;
  }

  return {
    pixels: routedPixels,
    plugins: {
      // keeps every other plugin, Google Tag Manager included, out of a pixel event
      all: false,
      ...Object.fromEntries(
        routedPixels.map(({ vendor }): [string, boolean] => [vendor, true]),
      ),
    },
  };
};
